import { Component, OnInit, OnDestroy } from '@angular/core';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { FaturamentoService } from 'src/app/services/http/faturamento.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { FaturamentoDetalhadoCliente } from 'src/app/models/faturamento-detalhado-cliente';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilMasks } from 'src/app/utils/util-masks';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Calendar } from 'primeng/calendar';
import { DetalhamentoFatura } from 'src/app/models/detalhamento-fatura';
import { LoginService } from 'src/app/services/login.service';
import { Usuario } from 'src/app/models/usuario-login';
// import { boleto } from 'boleto-brasileiro-validator';

@Component({
  selector: 'app-faturamento-detalhamento',
  templateUrl: './faturamento-detalhamento.component.html',
  styleUrls: ['./faturamento-detalhamento.component.scss']
})
export class FaturamentoDetalhamentoComponent implements OnInit, OnDestroy {

  idFaturamento: string;

  masks = {
    data: { mask: UtilMasks.data, guide: false },
  }

  dataVencimento = new FormControl('', [Validators.required, Validators.minLength(10)]);
  arquivoRetorno = new FormControl('', [Validators.required]);

  atualizarLista: boolean = true;
  loadingList: boolean = false;
  faturaUnidadeFaturante: boolean = false;
  faturamentoDetalhadoCliente: FaturamentoDetalhadoCliente = null;
  listaResultado: Array<DetalhamentoFatura> = [];
  listaIdsSelecionados = [];

  filtroSelecionadoNfe: any = null;
  listaFiltroNfe: any[] = [];

  tableLoading: boolean = false;

  rowDataInfo: DetalhamentoFatura = {} as DetalhamentoFatura;
  editStatus: DetalhamentoFatura = {} as DetalhamentoFatura;
  editStatusBoleto: DetalhamentoFatura = {} as DetalhamentoFatura;
  first: number = 0;
  faturamento: any = {};
  dynamicdownloadName: string = "Faturamento";
  quantidadePorPagina: number = 30;

  cols: any = [
    { field: 'idUnidade', header: 'ID' },
    { field: 'gerarNota', header: 'Tipo' },
    { field: 'nomeFantasia', header: 'Nome Fantasia' },
    { field: 'razaoSocial', header: 'Razão Social' },
    { field: 'documento', header: 'CNPJ' },
    // { field: 'valorTotal', header: 'Valor' },
    { field: 'valorTotalMod', header: 'Valor' },
    { field: 'statusFaturaClienteStr', header: 'Status' },
    { field: 'statusNfeStr', header: 'NFE - Status' },
    { field: 'numero', header: 'NFE - Número' },
    { field: 'dataTransacaoNfeStr', header: 'NFE - Data de Transação' },
    // { field: 'motivoStatusNfe', header: 'NFE - Motivo Status' },
    { field: 'statusBoletoStr', header: 'Boleto - Status' },
    { field: 'dataTransacaoBoletoStr', header: 'Boleto - Data Última Transação' },
    { field: 'dataVencimentoBoletoStr', header: 'Boleto - Data Vencimento' }
    // { field: 'motivoStatusBoleto', header: 'Boleto - Motivo Status' },
  ];

  statusBoletos = [
    { label: 'Cancelado', value: 'canceled' },
    { label: 'Pago', value: 'paid' },
    { label: 'Outros', value: 'others' },
    { label: 'Aguardando Remessa', value: 'waiting_approval' },
    { label: 'Reservado', value: 'reserved' },
    { label: 'Análise Pendente', value: 'pending-analysis' },
    { label: 'Ocorreu Erro', value: 'error' },
    { label: 'Completado', value: 'completed' },
    { label: 'Aguardando Pagamento', value: 'pending' },
    { label: 'Não Gerado', value: 'null' }
  ]

  statusBoletos2 = [
    { label: 'Cancelado', value: 'Cancelado' },
    { label: 'Pago', value: 'Pago' },
    { label: 'Outros', value: 'Outros' },
    { label: 'Aguardando Remessa', value: 'Aguardando Remessa' },
    { label: 'Reservado', value: 'Reservado' },
    { label: 'Análise Pendente', value: 'Análise Pendente' },
    { label: 'Ocorreu Erro', value: 'Ocorreu Erro' },
    { label: 'Completado', value: 'Completado' },
    { label: 'Aguardando Pagamento', value: 'Aguardando Pagamento' },
    { label: 'Não Gerado', value: 'Não Gerado' }
  ]

  statusFaturaCliente = [
    { label: 'Pendente', value: 'PENDENTE_VERIFICACAO' },
    { label: 'Verificado', value: 'VERIFICADO' },
    { label: 'Sem consumo', value: 'SEM_CONSUMO' },
    { label: 'Não Fatura', value: 'NAO_FATURAR' },
    { label: 'Finalizado', value: 'FINALIZADO' },
    { label: 'Não Gerada', value: 'null' }
  ]

  tipoFatura = [
    { label: 'FATURA', value: 'FATURA' },
    { label: 'RECIBO', value: 'RECIBO' },
    { label: 'Não tipado', value: 'null' }
  ]

  statusFaturaCliente2 = [
    { label: 'Pendente', value: 'Pendente' },
    { label: 'Verificado', value: 'Verificado' },
    { label: 'Sem consumo', value: 'Sem consumo' },
    { label: 'Não Fatura', value: 'Não Fatura' },
    { label: 'Finalizado', value: 'Finalizado' },
    { label: 'Não Gerada', value: 'Não Gerada' }
  ]

  statusNfe = [
    { label: 'Cancelada', value: 'cancelada' },
    { label: 'Erro', value: 'error' },
    { label: 'Aguadando Cancelamento', value: 'aguardandocancelamento' },
    { label: 'Autorizada', value: 'autorizada' },
    { label: 'Negada', value: 'negada' },
    { label: 'Aguardando Autorização', value: 'aguardandoautorizacao' },
    { label: 'Não Gerada', value: 'null' }
  ]

  statusNfe2 = [
    { label: 'Cancelada', value: 'Cancelada' },
    { label: 'Erro', value: 'Erro' },
    { label: 'Aguadando Cancelamento', value: 'Aguadando Cancelamento' },
    { label: 'Autorizada', value: 'Autorizada' },
    { label: 'Negada', value: 'Negada' },
    { label: 'Aguardando Autorização', value: 'Aguardando Autorização' },
    { label: 'Não Gerada', value: 'Não Gerada' }
  ]

  displayBoleto: boolean = false;
  displayNota: boolean = false;
  displayEditarStatus: boolean = false;
  displayEditarStatusBoleto: boolean = false;

  uploadBoleto: Boleto = new Boleto();
  uploadNota: Nota = new Nota();

  disableAll: boolean = false;
  usuario: Usuario;

  constructor(private formBuilder: FormBuilder, private faturamentoService: FaturamentoService, private msgModal: ModalMsgService, private modalService: NgbModal, private activedRoute: ActivatedRoute, private loginService: LoginService, private router: Router) {
    this.loginService.getLogIn().subscribe(l => this.usuario = l);
    if (!this.usuario.permissoes.faturamento_matriz) {
      this.router.navigate(['error/401'])
    }
    this.activedRoute.params.pipe(first()).subscribe(r => this.idFaturamento = r.idFaturamento || null);
    Calendar.prototype.getDateFormat = () => 'dd/mm/yy';
    this.uploadBoleto = new Boleto();
    this.uploadNota = new Nota();
    this.uploadBoleto.clean(this.formBuilder);
    this.uploadNota.clean(this.formBuilder);
  }

  ngOnInit() {
    this.buscarLista();
    // this.atualizarListaSleep();
    this.rowDataInfo.motivoStatusBoleto = "";
  }

  ngOnDestroy() {
    this.atualizarLista = false;
  }

  setQuantidadePorPagina(quantidadeNova: number) {
    this.quantidadePorPagina = quantidadeNova;
  }

  deleteFile() {
    this.arquivoRetorno.patchValue('');
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.arquivoRetorno.setValue(file);
    }
  }

  checkSelecionadosTabela() {
    if (this.listaIdsSelecionados.length > 0 && this.listaIdsSelecionados.length >= this.listaResultado.length)
      return "TODOS";
    if (this.listaIdsSelecionados.length > 0)
      return "ALGUNS";
    return "NENHUM";
  }

  selecionarTodosRegistro() {
    if (this.listaIdsSelecionados.length == this.listaResultado.length) {
      this.listaResultado.forEach(r => r.check = false);
      this.listaIdsSelecionados = [];
    } else {
      this.listaResultado.forEach(r => r.check = true);
      this.listaIdsSelecionados = [...this.listaResultado.map(r => r.id)];
    }
  }

  selecionarRegistro(registroSelecionado) {
    registroSelecionado.check = !registroSelecionado.check;
    if (registroSelecionado.check)
      this.listaIdsSelecionados.push(registroSelecionado.id);
    else
      this.listaIdsSelecionados.splice(this.listaIdsSelecionados.indexOf(registroSelecionado.id), 1);
  }

  tratarListaTela(result) {
    this.faturamentoDetalhadoCliente = result;
    this.faturaUnidadeFaturante = result.faturamentoDetalhado.faturaUnidadeFaturante;

    this.listaResultado = [...result.listaFaturamentoCliente.map(item => ({ ...item, check: this.listaIdsSelecionados.find(x => x == item.id) == null ? false : true }))];
    this.listaResultado.forEach(r => {
      r.statusBoleto = r.statusBoleto + '';
      r.statusNfe = r.statusNfe + '';
      if (r.numero == null || r.numero == '') {
        r.numero = "Não Gerada";
      }
      r.dataTransacaoNfeStr = this.dataFormatada(r.dataTransacaoNfe);
      r.dataTransacaoBoletoStr = this.dataFormatada(r.dataTransacaoBoleto);
      r.dataVencimentoBoletoStr = this.dataFormatada(r.dataVencimentoBoleto);
      r.statusFaturaClienteStr = this.statusFaturaFormatado(r.statusFaturaCliente);
      r.statusBoletoStr = this.statusBoletoFormatado(r.statusBoleto);
      r.statusNfeStr = this.statusNfeFormatado(r.statusNfe);
    });
    let listaStatusNota = Object.keys(this.agruparRegistros(this.listaResultado, "statusNfe"));
    if (listaStatusNota.indexOf("null") >= 0) {
      listaStatusNota.splice(listaStatusNota.indexOf("null"), 1);
    }
    this.listaFiltroNfe = [...listaStatusNota.map(item => ({ texto: item.toUpperCase(), valor: item }))];

    if (this.filtroSelecionadoNfe != null)
      this.filtroSelecionadoNfe = this.listaFiltroNfe.find(x => x.valor == this.filtroSelecionadoNfe.valor);


  }

  statusFaturaFormatado(status: string): string {
    var retorno: string = 'Não Gerada';
    this.statusFaturaCliente.map(sfc => {
      if (sfc.value == status) {
        retorno = sfc.label
        return sfc.label
      }
    })
    return retorno;
  }

  statusBoletoFormatado(status: string): string {
    var retorno: string = 'Não Gerado';
    this.statusBoletos.map(sb => {
      if (sb.value == status) {
        retorno = sb.label
        return sb.label
      }
    })
    return retorno;
  }

  statusNfeFormatado(status: string): string {
    var retorno: string = 'Não Gerada';
    this.statusNfe.map(snfe => {
      if (snfe.value == status) {
        retorno = snfe.label
        return snfe.label
      }
    })
    return retorno;
  }

  dataFormatada(dataStr: string): string {
    if (dataStr != null && dataStr != undefined && dataStr != '') {
      var data = new Date(dataStr),
        dia = data.getDate().toString(),
        diaF = (dia.length == 1) ? '0' + dia : dia,
        mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
        mesF = (mes.length == 1) ? '0' + mes : mes,
        anoF = data.getFullYear(),
        hora = data.toISOString().substr(11, 8),
        horaF = parseInt(hora.split(':')[0]) - 3 + ':' + hora.split(':')[1] + ':' + hora.split(':')[2];
      return diaF + "/" + mesF + "/" + anoF + " " + horaF;
    }
    else {
      return 'Não Gerad';
    }
  }

  buscarLista(ignore = []) {
    if (ignore.includes('loading'))
      this.loadingList = true;
    return this.faturamentoService.carregarDetalhesFaturamento(this.idFaturamento, ignore).then(result => {
      this.tratarListaTela(result)
      if (ignore.includes('loading'))
        this.loadingList = false;
    });
  }

  // atualizarListaSleep() {
  //   setTimeout(() => {
  //     if (this.atualizarLista)
  //       this.buscarLista(['loading']).finally(() => {
  //         this.atualizarListaSleep();
  //       });
  //   }, 10000);
  // }



  clickFiltroStatusNfe(selectedValue: any) {
    this.filtroSelecionadoNfe = selectedValue;
    this.tratarListaTela(this.faturamentoDetalhadoCliente);
  }

  carregarListaFiltro() {
    return this.listaResultado.filter(r => this.listaIdsSelecionados.find(x => x == r.id) != null)
  }

  agruparRegistros(array, key) {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []);
      return result;
    }, {});
    // return array.reduce((result, currentValue) => {
    //   (result[currentValue[key]] = result[currentValue[key]] || []).push(
    //     currentValue
    //   );
    //   return result;
    // }, {});
  }

  marcarClientesNaoFaturar() {
    let listaFiltrada = this.carregarListaFiltro();

    let grupoStatus = Object.keys(this.agruparRegistros(listaFiltrada, "statusFaturaCliente"));

    if (grupoStatus.length > 1) {
      this.msgModal.openDialog('Selecione clientes com o mesmo status',
        'Verifique se selecionou somente clientes que possuem o mesmo status', 'danger');
      return;
    }

    if (grupoStatus[0] != 'PENDENTE_VERIFICACAO') {
      this.msgModal.openDialog('Selecione somente clientes com status PENDENTE_VERIFICACAO',
        'Verifique se selecionou somente clientes que possuem o status PENDENTE_VERIFICACAO', 'danger');
      return;
    }

    return this.faturamentoService.enviarNaoFaturar(this.idFaturamento, listaFiltrada.map(x => x.idUnidade)).then(result => {
      this.listaIdsSelecionados = [];
      this.buscarLista(['loading']).finally(() => {
        this.buscarLista();
      });
    });
  }

  cancelarNota() {
    let listaFiltrada = this.carregarListaFiltro();

    let grupoStatus = Object.keys(this.agruparRegistros(listaFiltrada, "statusFaturaCliente"));

    if (grupoStatus.length > 1) {
      this.msgModal.openDialog('Selecione clientes com o mesmo status',
        'Verifique se selecionou somente clientes que possuem o mesmo status', 'danger');
      return;
    }

    if (grupoStatus[0] != 'VERIFICADO') {
      this.msgModal.openDialog('Selecione somente clientes com status VERIFICADO',
        'Verifique se selecionou somente clientes que possuem o status VERIFICADO', 'danger');
      return;
    }

    let listaNaoGeraNota = ["autorizada"];

    let listaGerarNota = listaFiltrada.filter(x => listaNaoGeraNota.find(n => n == x.statusNfe))

    return this.faturamentoService.enviarCancelarNota(this.idFaturamento, listaGerarNota.map(x => x.idNfe)).then(result => {
      this.listaIdsSelecionados = [];
      this.buscarLista(['loading']).finally(() => {
        this.buscarLista();
      });
    });
  }

  gerarNota() {
    let listaFiltrada = this.carregarListaFiltro();

    let grupoStatus = Object.keys(this.agruparRegistros(listaFiltrada, "statusFaturaCliente"));

    if (grupoStatus.length > 1) {
      this.msgModal.openDialog('Selecione clientes com o mesmo status',
        'Verifique se selecionou somente clientes que possuem o mesmo status', 'danger');
      return;
    }

    if (grupoStatus[0] != 'VERIFICADO') {
      this.msgModal.openDialog('Selecione somente clientes com status VERIFICADO',
        'Verifique se selecionou somente clientes que possuem o status VERIFICADO', 'danger');
      return;
    }

    // let grupoStatusNfe = Object.keys(this.agruparRegistros(listaFiltrada, "statusNfe"));
    // error
    // cancelada
    // aguardandoautorizacao
    // autorizada
    let listaNaoGeraNota = ["autorizada", "aguardandoautorizacao", "aguardandocancelamento", "initial"];

    let listaGerarNota = listaFiltrada.filter(x => !listaNaoGeraNota.find(n => n == x.statusNfe))

    return this.faturamentoService.enviarGerarNota(this.idFaturamento, listaGerarNota.map(x => x.idUnidade)).then(result => {
      this.listaIdsSelecionados = [];
      this.buscarLista(['loading']).finally(() => {
        this.buscarLista();
      });
    });

  }

  gerarRemessaBoleto() {
    let listaFiltrada = this.carregarListaFiltro();

    let grupoStatus = Object.keys(this.agruparRegistros(listaFiltrada, "statusFaturaCliente"));

    if (grupoStatus.length > 1) {
      this.msgModal.openDialog('Selecione clientes com o mesmo status',
        'Verifique se selecionou somente clientes que possuem o mesmo status', 'danger');
      return;
    }

    if (grupoStatus[0] != 'VERIFICADO') {
      this.msgModal.openDialog('Selecione somente clientes com status VERIFICADO',
        'Verifique se selecionou somente clientes que possuem o status VERIFICADO', 'danger');
      return;
    }

    let listaNaoGeraNota = [];
    // let listaNaoGeraNota = ["autorizada", "aguardandoautorizacao", "aguardandocancelamento", "initial"];

    let listaGerarNota = listaFiltrada.filter(x => !listaNaoGeraNota.find(n => n == x.statusNfe))

    return this.faturamentoService.enviarRemssaBoleto(this.idFaturamento, listaGerarNota.map(x => x.idUnidade)).then(result => {

      window.open(result['url']);

      this.listaIdsSelecionados = [];
      this.buscarLista(['loading']).finally(() => {
        this.buscarLista();
      });
    });

  }

  gerarBoleto(dataVencimento: string) {
    let listaFiltrada = this.carregarListaFiltro();

    let grupoStatus = Object.keys(this.agruparRegistros(listaFiltrada, "statusFaturaCliente"));

    if (grupoStatus.length > 1) {
      this.msgModal.openDialog('Selecione clientes com o mesmo status',
        'Verifique se selecionou somente clientes que possuem o mesmo status', 'danger');
      return;
    }

    if (grupoStatus[0] != 'VERIFICADO') {
      this.msgModal.openDialog('Selecione somente clientes com status VERIFICADO',
        'Verifique se selecionou somente clientes que possuem o status VERIFICADO', 'danger');
      return;
    }

    // let grupoStatusNfe = Object.keys(this.agruparRegistros(listaFiltrada, "statusNfe"));
    // error
    // cancelada
    // aguardandoautorizacao
    // autorizada

    let listaNaoGeraBoleto = ["paid"];

    let listaGerarNota = listaFiltrada.filter(x => !listaNaoGeraBoleto.find(n => n == x.statusBoleto))

    let dataVencimentoDate = new Date(Number.parseInt(dataVencimento.split("/")[2]), Number.parseInt(dataVencimento.split("/")[1]) - 1, Number.parseInt(dataVencimento.split("/")[0]));

    let objGerarBoleto = {
      dateVencimento: dataVencimentoDate.getTime(),
      listaIdUnidade: listaGerarNota.map(x => x.idUnidade)
    }
    return this.faturamentoService.enviarGerarBoleto(this.idFaturamento, objGerarBoleto).then(result => {
      this.listaIdsSelecionados = [];
      this.buscarLista(['loading']).finally(() => {
        this.dataVencimento.value.patchValue('');
        this.buscarLista();
      });
    });

  }

  openModal(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.gerarBoleto(this.dataVencimento.value);
    }, (reason) => {
      // console.info("reason", reason);
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openModalRemessa(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      let form = this.arquivoRetorno;
      return this.faturamentoService.enviarArquivoRetorno(form.value).then(result => {
        this.msgModal.openDialog('Arquivo enviado com sucesso', '', 'success');
        this.listaIdsSelecionados = [];
        this.buscarLista(['loading']).finally(() => {
          this.buscarLista();
        });
      }).catch(() => {
        this.msgModal.openDialog('Erro', 'Arquivo não foi enviado', '', 'danger');
      });

    }, (reason) => {
      // console.info("reason", reason);
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  enviarAnexos() {
    let listaFiltrada = this.carregarListaFiltro();

    let grupoStatus = Object.keys(this.agruparRegistros(listaFiltrada, "statusFaturaCliente"));

    // if (grupoStatus.length > 1) {
    //   this.msgModal.openDialog('Selecione clientes com o mesmo status',
    //     'Verifique se selecionou somente clientes que possuem o mesmo status', 'danger');
    //   return;
    // }

    // if (grupoStatus[0] != 'VERIFICADO') {
    //   this.msgModal.openDialog('Selecione somente clientes com status VERIFICADO',
    //     'Verifique se selecionou somente clientes que possuem o status VERIFICADO', 'danger');
    //   return;
    // }

    // let grupoStatusNfe = Object.keys(this.agruparRegistros(listaFiltrada, "statusNfe"));
    // error
    // cancelada
    // aguardandoautorizacao
    // autorizada

    return this.faturamentoService.enviarAnexos(this.idFaturamento, listaFiltrada.map(x => x.idUnidade)).then(result => {
      this.msgModal.openDialog('Email enviado com sucesso', '', 'success');
      this.listaIdsSelecionados = [];
      this.buscarLista(['loading']).finally(() => {
        this.buscarLista();
      });
    }).catch(() => {
      this.msgModal.openDialog('Erro', 'Email não foi enviado', '', 'danger');
    });

  }

  clean() {
    this.uploadBoleto.clean(this.formBuilder);
    this.uploadNota.clean(this.formBuilder);
    this.disableAll = false
  }

  onUpload(event, flag: string) {
    //this.msgModal.openDialog('Aguarde', 'Fazendo upload... aguarde', '', 'info');
    this.clean();
    this.disableAll = true
    let fileI: any = null

    if (flag == 'BoletoPDF') {
      for (let file of event.files) {
        fileI = file
        this.uploadBoleto.arquivo.uploadForm.get('profile').setValue(file);
      }
      this.uploadBoleto.arquivo.formData.append('arquivo', this.uploadBoleto.arquivo.uploadForm.get('profile').value);

      this.msgModal.openDialog('Sucesso', 'Arquivo de boleto(PDF) pronto para ser enviado!', '', 'info');
    }
    else if (flag == 'NotaPDF') {
      for (let file of event.files) {
        fileI = file
        this.uploadNota.arquivoPDF.uploadForm.get('profile').setValue(file);
      }
      this.uploadNota.arquivoPDF.formData.append('arquivo', this.uploadNota.arquivoPDF.uploadForm.get('profile').value);
      this.msgModal.openDialog('Sucesso', 'Arquivo de nota(PDF) pronto para ser enviado!', '', 'info');
    }
    else if (flag == 'NotaXML') {
      for (let file of event.files) {
        fileI = file
        this.uploadNota.arquivoXML.uploadForm.get('profile').setValue(file);
      }
      this.uploadNota.arquivoXML.formData.append('arquivo', this.uploadNota.arquivoXML.uploadForm.get('profile').value);
      this.msgModal.openDialog('Sucesso', 'Arquivo de nota(XML) pronto para ser enviado', '', 'info');
    }
  }

  updateBoleto() {
    if (this.uploadBoleto.isValid()) {
      this.uploadBoleto.arquivo.formData.append('valor', this.uploadBoleto.valor.toString());
      this.uploadBoleto.arquivo.formData.append('vencimento', this.uploadBoleto.vencimento.toString());
      this.displayBoleto = false;
      this.faturamentoService.enviarPdfBoleto(this.idFaturamento, this.rowDataInfo.idUnidade, this.uploadBoleto.arquivo.formData)
        .then(e => {
          this.clean();
          this.ngOnInit();
          this.msgModal.openDialog('Sucesso', 'Boleto enviado com sucesso!', '', 'info');
        })
        .catch(e => {
          this.msgModal.openDialog('Erro ao enviar boleto',
            (e.error.error != undefined ? e.error.error : 'Verifique o problema com o suporte'), 'danger');
          console.error(e)
        });
    }
    else {
      this.msgModal.openDialog('Alerta', 'Informe os campos necessários!', '', 'warning');
    }
  }

  updateNota() {
    if (this.uploadNota.mesCompetencia > 0 != null && this.uploadNota.mesCompetencia != undefined && this.uploadNota.mesCompetencia > 0 &&
      this.uploadNota.anoCompetencia > 0 != null && this.uploadNota.anoCompetencia != undefined && this.uploadNota.anoCompetencia > 0 &&
      ((this.uploadNota.arquivoPDF.uploadForm != null && this.uploadNota.arquivoPDF.formData.get('arquivo') != null) ||
        (this.uploadNota.arquivoXML.uploadForm != null && this.uploadNota.arquivoXML.formData.get('arquivo') != null))) {

      this.uploadNota.formData.append('mesCompetencia', this.uploadNota.mesCompetencia.toString());
      this.uploadNota.formData.append('anoCompetencia', this.uploadNota.anoCompetencia.toString());
      this.uploadNota.formData.append('arquivoPDF', this.uploadNota.arquivoPDF.uploadForm.get('profile').value);
      this.uploadNota.formData.append('arquivoXML', this.uploadNota.arquivoXML.uploadForm.get('profile').value);
      this.displayNota = false;
      this.faturamentoService.enviarNotaFiscal(this.rowDataInfo.uuidFaturamento, this.rowDataInfo.uuidUnidade, this.uploadNota.formData)
        .then(e => {
          this.clean();
          this.ngOnInit();
          this.msgModal.openDialog('Sucesso', 'Nota Fiscal enviada com sucesso!', '', 'info');
        })
        .catch(e => {
          this.msgModal.openDialog('Erro ao enviar nota fiscal',
            (e.error.error != undefined ? e.error.error : 'Verifique o problema com o suporte'), 'danger');
          console.error(e)
        });
    }
    else {
      this.msgModal.openDialog('Alerta', 'Informe os campos necessários!', '', 'warning');
    }
  }

  salvarStatus() {
    if (this.editStatus.statusFaturaClienteNovo != null && this.editStatus.statusFaturaClienteNovo != undefined) {
      this.displayEditarStatus = false;
      this.faturamentoService.atualizarStatusFaturamentoCliente(this.editStatus)
        .then(result => {
          this.clean();
          this.ngOnInit();
          this.msgModal.openDialog('Sucesso', 'Mudança de status do ID da unidade ' + this.editStatus.idUnidade + ' salvo com sucesso!', '', 'info');
        })
        .catch(e => {
          this.msgModal.openDialog('Erro ao alterar status do ID da unidade ' + this.editStatus.idUnidade,
            (e.error.error != undefined ? e.error.error : 'Verifique o problema com o suporte'), 'danger');
          console.error(e)
        });
    }
    else {
      this.msgModal.openDialog('Alerta', 'Informe os campos necessários!', '', 'warning');
    }
  }

  salvarStatusBoleto() {
    if (this.editStatusBoleto.statusBoletoNovo != null && this.editStatusBoleto.statusBoletoNovo != undefined) {
      this.displayEditarStatusBoleto = false;
      this.faturamentoService.atualizarStatusFaturamentoCliente(this.editStatus)
        .then(result => {
          this.clean();
          this.ngOnInit();
          this.msgModal.openDialog('Sucesso', 'Mudança de status do Boleto da unidade ' + this.editStatus.idUnidade + ' salvo com sucesso!', '', 'info');
        })
        .catch(e => {
          this.msgModal.openDialog('Erro ao alterar status do boleto da unidade ' + this.editStatus.idUnidade,
            (e.error.error != undefined ? e.error.error : 'Verifique o problema com o suporte'), 'danger');
          console.error(e)
        });
    }
    else {
      this.msgModal.openDialog('Alerta', 'Informe os campos necessários!', '', 'warning');
    }
  }

}

class Nota {
  arquivoXML: UploadArquivo;
  arquivoPDF: UploadArquivo;
  mesCompetencia: number;
  anoCompetencia: number;
  formData: FormData = new FormData();
  mesStr = [
    { label: 'Janeiro', value: 1 },
    { label: 'Fevereiro', value: 2 },
    { label: 'Março', value: 3 },
    { label: 'Abril', value: 4 },
    { label: 'Maio', value: 5 },
    { label: 'Junho', value: 6 },
    { label: 'Julho', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Setembro', value: 9 },
    { label: 'Outubro', value: 10 },
    { label: 'Novembro', value: 11 },
    { label: 'Dezembro', value: 12 },
  ]

  clean(formBuilder: FormBuilder) {
    this.mesCompetencia = (new Date()).getMonth() + 1;
    this.anoCompetencia = (new Date()).getFullYear();
    this.arquivoXML = new UploadArquivo();
    this.arquivoPDF = new UploadArquivo();
    this.arquivoXML.clean(formBuilder);
    this.arquivoPDF.clean(formBuilder);
    this.formData = new FormData();
  }

}

class Boleto {
  vencimento: Date;
  valor: number;
  arquivo: UploadArquivo;

  clean(formBuilder: FormBuilder) {
    this.vencimento = new Date();
    this.valor = null;
    this.arquivo = new UploadArquivo();
    this.arquivo.clean(formBuilder);
  }

  isValid(): boolean {
    if (this.valor != null && this.valor > 0 &&
      this.vencimento != null && this.vencimento != undefined &&
      this.arquivo.uploadForm != null && this.arquivo.formData.get('arquivo') != null) {
      return true;
    }
    else {
      return false;
    }
  }
}

class UploadArquivo {
  uploadedFiles: any[] = [];
  uploadForm: FormGroup;
  formData: FormData = new FormData();

  clean(formBuilder: FormBuilder) {
    this.uploadForm = formBuilder.group({ profile: [''] });
    this.formData = new FormData();
    this.uploadedFiles = [];
  }
}
